import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
// @ts-ignore
import { useStore } from '@/store';
// @ts-ignore
import ErrorModal from '@/components/widgets/ErrorModal.vue';
// @ts-ignore
import BeforeLogoutModal from '@/components/widgets/BeforeLogoutModal.vue';
// @ts-ignore
import { isTestcafeEnabled, isTestcafeAuthEnabled } from '@/utils/testCafe';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const errorAlert = ref(false);
const testCafe = computed<boolean>(() => isTestcafeEnabled() || isTestcafeAuthEnabled());
const store = useStore();

const appVersion = computed(() => process.env.APP_VERSION);

watch(
    () => store.getters.getErrors,
    () => {
        errorAlert.value = true;
    }
);

store.dispatch('checkLogin');


return { __sfc: true,errorAlert, testCafe, store, appVersion, ErrorModal, BeforeLogoutModal }
}

})